import {AfterViewInit, Component, inject, signal} from '@angular/core';
import {AuthService} from './@core/services/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.css'
})
export class App implements AfterViewInit{
  protected readonly title = signal('nbha-portal');
  isLoggedIn: boolean = false
  currentPath = '';

  constructor(private authService: AuthService, private router: Router) {
    this.authService.init();
    this.authService.isAuthenticated.subscribe((data) => {
      console.log("isAuthenticated", data)
      this.isLoggedIn = data
    })
    // Initialize currentPath immediately
    this.currentPath = this.router.url;
  }

  private keenInit() {
    const w = window as any;

    // Global app/layout
    w.KTApp?.init?.();
    w.KTLayout?.init?.();

    // Create instances for data-kt-* components used in your header
    w.KTMenu?.init?.();
    w.KTDrawer?.init?.();
    w.KTScroll?.init?.();
    w.KTSticky?.init?.();
    w.KTToggle?.init?.();     // generic toggles (if present)
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.currentPath = event.url;
    });
  }

  ngAfterViewInit() {
    this.keenInit(); // first paint
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => setTimeout(() => this.keenInit()));
  }
}
